import React from 'react'
import { Input } from './input';
import { useForm } from "react-hook-form"
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from './form';
import { Button } from './button';
import { ProblemSetVisibilityEnum } from '~/lib/objects';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';
import SpinnerCircle4 from './spinner';

interface ProblemSetEditorProps {
    problemSetTitle: string;
    visibility: ProblemSetVisibilityEnum;
    onSubmit: (data: ProblemSetInput) => void;
    busy?: boolean;
    disabled?: boolean;
    showValidationErrors?: boolean;
    visibilityPortalContainer?: HTMLElement | null;
}

type ProblemSetInput = {
    title: string;
    visibility: ProblemSetVisibilityEnum;
}

export const ProblemSetEditor = ({ problemSetTitle, visibility, onSubmit, busy, disabled, showValidationErrors, visibilityPortalContainer }: ProblemSetEditorProps) => {
    const form = useForm<ProblemSetInput>({
        defaultValues: {
            title: problemSetTitle,
            visibility
        }
    });
    const { handleSubmit, control } = form;

    return (
        <Form {...form}>
            <div className="relative">
                {busy && (
                    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 dark:bg-black/60 pointer-events-auto" style={{ backdropFilter: 'blur(2px)' }}>
                        <SpinnerCircle4 style={{ width: 40, height: 40 }} />
                    </div>
                )}
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 pointer-events-auto" style={busy ? { pointerEvents: 'none', opacity: 0.7 } : {}}>
                    <FormField
                        control={control}
                        name="title"
                        rules={{ required: "Это поле обязательно для заполнения" }}
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Название набора задач</FormLabel>
                                <FormControl>
                                    <Input
                                        disabled={disabled}
                                        placeholder="Введите название набора задач"
                                        defaultValue={field.value}
                                        {...field}
                                    />
                                </FormControl>
                                <FormDescription />
                                {showValidationErrors && <FormMessage />}
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={control}
                        name="visibility"
                        rules={{ required: "Это поле обязательно для заполнения" }}
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Видимость набора задач</FormLabel>
                                <Select disabled={disabled} onValueChange={(value) => { if (!disabled) field.onChange(value); }} defaultValue={field.value}>
                                    <FormControl>
                                        <SelectTrigger disabled={disabled}>
                                            <SelectValue placeholder="Выберите видимость" />
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent {...field} portalContainer={visibilityPortalContainer}>
                                        <SelectItem disabled={disabled} value={ProblemSetVisibilityEnum.PUBLIC}>Публичный</SelectItem>
                                        <SelectItem disabled={disabled} value={ProblemSetVisibilityEnum.PRIVATE}>Приватный</SelectItem>
                                        <SelectItem disabled={disabled} value={ProblemSetVisibilityEnum.HIDDEN}>Скрытый</SelectItem>
                                    </SelectContent>
                                </Select>
                                <FormDescription />
                                {showValidationErrors && <FormMessage />}
                            </FormItem>
                        )}
                    />

                    <Button type="submit" disabled={busy === true || disabled === true}>Сохранить</Button>
                </form>
            </div>
        </Form>
    );
};
